import { isValidElement } from 'react';
import { isReactComponent } from '../is-react';
export function isCustomView(obj) {
  return obj && ( /*#__PURE__*/isValidElement(obj) || isReactComponent(obj));
}